const index = () => import('../views/myprotein-test/index.vue')
const myproteinQuiz = () => import('../views/myprotein-test/myproteinQuiz.vue')
const myproteinResult = () => import('../views/myprotein-test/myproteinResult.vue')
const myproteinConfirm = () => import('../views/myprotein-test/calculate.vue')
const myproteinResultScore = () => import('../views/myprotein-test/myproteinQuizAnswerResult.vue')

const myproteinDetail = () => import('../views/myprotein-test/myproteinDetail.vue')

const myproteinInfo01 = () => import('../views/myprotein-test/myproteinInfo01.vue')
const myproteinInfo02 = () => import('../views/myprotein-test/myproteinInfo02.vue')
const myproteinInfo03 = () => import('../views/myprotein-test/myproteinInfo03.vue')


export default [

    // 시작화면
    {
        name : 'myprotein-index',
        path : '/myprotein',
        component : index
    },

    // 퀴즈화면
    {
        name :'myprotein-quiz',
        path : '/quiz',
        component : myproteinQuiz
    },
    {
        name : 'myprotein-confirm',
        path : '/myprotein-calculate',
        component : myproteinConfirm
    },

    // 퀴즈결과 화면
    {
        name :'myprotein-result',
        path : '/myprotein-result',
        component : myproteinResult
    },

    // 퀴즈 정답결과
    {
        name :'myprotein-answer-result',
        path : '/myprotein-answer-result',
        component : myproteinResultScore
    },

    // 주요식품별 단백질 함량 알아보기
    {
        name :'myprotein-detail',
        path : '/myprotein-detail',
        component : myproteinDetail
    },

    {
        name :'myprotein-info01',
        path : '/myprotein-info01',
        component : myproteinInfo01
    },

    {
        name :'myprotein-info02',
        path : '/myprotein-info02',
        component : myproteinInfo02
    },
    {
        name :'myprotein-info03',
        path : '/myprotein-info03',
        component : myproteinInfo03
    }
]
